import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202609: BlogMetaData = {
  title: '2026年9月の入園見学会開催について',
  description:
    '2027年度入園をご検討中のご家庭向けに、9月に3日程で入園見学会を開催します。モンテッソーリのお仕事見学と個別Q&Aを行います。',
  thumbnailUrl: '/img/blog-202509-session-info.webp',
  filePath: buildBlogFilePath('2026_09-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
